export enum UndoRedo {
  UNDO = 'UNDO',
  REDO = 'REDO'
}

export enum Zoom {
  IN = 2,
  OUT = .5
}

export enum SwitchImage {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS'
}